import { rankingItems } from '@/mocks/homeData';

export default function SectionRanking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            本周播放量最高的热门剧集，大家都在追的好剧都在这儿
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-5 px-4 py-3.5 md:py-4 border-b border-background-200/70 last:border-0 hover:bg-background-50/60 transition-colors rounded-lg group cursor-pointer"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-secondary-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-400 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                <span className="text-sm md:text-base font-bold font-heading">
                  {item.rank}
                </span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  {item.change === 'up' && (
                    <i className="ri-arrow-up-fill text-green-500 text-xs"></i>
                  )}
                  {item.change === 'down' && (
                    <i className="ri-arrow-down-fill text-red-500 text-xs"></i>
                  )}
                  {item.change === 'new' && (
                    <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 text-[10px] font-medium whitespace-nowrap">NEW</span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 whitespace-nowrap">
                  {item.category} · {item.hot}
                </p>
              </div>

              <span className="text-xs md:text-sm text-foreground-400 whitespace-nowrap flex-shrink-0">
                {item.episodes}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}